<template>
  <div class="home">
    InternationalEconomy
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'InternationalEconomy',
  components: {
  }
}
</script>
